import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const CreacionTrasladoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAcopios = async (params) => {
        return api
            .get("acopio", params)
            .then((response) => {
                const acopios =
                    response && response.results
                        ? response.results.slice()
                        : [];
                return acopios;
            })
            .catch(() => []);
    };

    const getPilotos = async (params) => {
        return api
            .get("piloto", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getVehiculos = async (params) => {
        return api
            .get("vehiculo", params)
            .then((data) => {
                if (data) {
                    const datos = data.results;
                    datos.forEach((dato) => {
                        dato.nombre = `${dato.tipo_vehiculo.nombre} ${dato.placa}`;
                    });
                    return datos;
                }
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const crearTraslado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslados",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        crearTraslado,
        getAcopios,
        getPilotos,
        getVehiculos,
        cargando,
    };
};
